export enum SearchArea {
  INTERNET,
  FILES,
  LOCATIONS,
  PUSHPINS,
  TERRITORIES,
}
